import React, {useContext} from "react";
import { useDispatch } from 'react-redux';
import AppContext from '../../shared/components/AppContext';
import { onChangeModalSubscription } from "../../redux/actions/ActionApp";
import { useTranslation } from 'react-i18next';


// CSS 
import "../../../styles/PlanModal.scss";
import "../../../styles/TablePricing.scss";
import TablePricing from "./TablePricing";


/**
 * It takes in a dispatch function as an argument and returns a function that dispatches an action to
 * change the modal subscription state
 * @param dispatch - This is the dispatch function that is passed to the component by the connect
 * function.
 */
const onCloseModal = (dispatch) => {
    dispatch(onChangeModalSubscription());  
} 

 
/**
 * It returns a div with the className "PlanModal active" and the name "Plan Modal"
 * @returns A div with the className "PlanModal active"
 */
export default function PlanModal() {
    const { t } = useTranslation();
    const myContext = useContext(AppContext); 
    const dispatch = useDispatch();

        return (
        <div name="Plan Modal active" key="idModalReturn" className="PlanModal">
            <div className="PlanModal-container">
                {
                    myContext.user?.subscription_type !== "None" ?
                        <div onClick={() => onCloseModal(dispatch)}
                             className="closeWindow"></div>
                    : <></>
                }

                <h2>{t('PLAN_MODAL.TITLE')}</h2>
                <TablePricing isHome={false} myContext={myContext}/>
            </div>
        </div>
    )
};
